import React from 'react';
import PropTypes from 'prop-types';
import { Well, Button } from 'react-bootstrap';
import numeral from 'numeral';

const PaymentTotal = ({ sum, onClick }) => (
  <div className="row">
    <div className="col-xs-12">
      <Well className="PaymentWell" bsSize="small">
        <div className="row">
          <div className="col-xs-9">
            <div className="form-group form-inline">
              <label>Total Amount Selected:</label>
              <label>{numeral(sum).format('$0,0.00')}</label>
            </div>
          </div>
          <div className="col-xs-3">
            <Button className="btn-block" bsStyle="danger" disabled={!sum > 0} onClick={onClick}>
              Pay Now
            </Button>
          </div>
        </div>
      </Well>
    </div>
  </div>
);

PaymentTotal.propTypes = {
  sum: PropTypes.number,
  onClick: PropTypes.func,
};

PaymentTotal.defaultProps = {
  sum: 0,
  onClick: () => null,
};

export default PaymentTotal;



// WEBPACK FOOTER //
// ./src/components/PaymentTotal.js